import { DropDownCategories } from 'src/types/generic';
import {
  ManageSupplierType,
  ManageSupplierTypeFilterItem,
} from 'src/types/manage-suppliers/ManageSupplier';

/** Viewports below this width (tablets / small laptops) use compact responsive layouts. */
export const MANAGE_SUPPLIERS_LAPTOP_MIN_WIDTH_PX = 1280;

export const SUPPLIER_TYPE_FILTER_ITEMS: ManageSupplierTypeFilterItem[] = [
  { field: 'hosted', title: 'Hosted Suppliers', show: true, display: true },
  { field: 'offline', title: 'Offline Suppliers', show: true, display: true },
  { field: 'punchout', title: 'Punchout Suppliers', show: true, display: true },
];

export const SUPPLIER_STATUS_FILTER_CATEGORIES: DropDownCategories[] = [
  { value: 0, label: 'Show Active' },
  { value: 1, label: 'Show Inactive' },
  { value: 5, label: 'Show All' },
  { value: 2, label: 'Show Archived' },
  { value: 3, label: 'Show All Mapped' },
  { value: 4, label: 'Show All Unmapped' },
];

export const DEFAULT_SUPPLIER_STATUS_FILTER = SUPPLIER_STATUS_FILTER_CATEGORIES[0];
export const SUPPLIER_STATUS_FILTER_SHOW_ALL = 5;

// Client-side grid paging/sort/column filters via Kendo process(). Default page size matches the grid pager.
export const SUPPLIERS_DEFAULT_PAGE_SIZE = 100;

export const SUPPLIER_GRID_TO_API_FIELD: Record<string, string> = {
  supplierName: 'supplierCompanyName',
  catalog: 'catalogName',
  contactName: 'contact',
  address: 'addressLine1',
  phone: 'phoneNumber',
  stateProvince: 'state',
  zipPostalCode: 'zipCode',
};

// Type-dropdown selection -> supplierFilters codes (backend enum: All=0, Hosted=1, Offline=2,
// Punchout=3). All types selected -> [SUPPLIER_TYPE_FILTER_ALL].
export const SUPPLIER_TYPE_FILTER_ALL = 0;
export const SUPPLIER_TYPE_FILTER_CODE: Record<ManageSupplierType, number> = {
  hosted: 1,
  offline: 2,
  punchout: 3,
};

// Maximum number of companies per supplier export request, if current user has access to >50 companies.
export const SUPPLIER_EXPORT_COMPANY_CHUNK_SIZE = 100;

// Maximum number of export chunk requests in flight at the same time.
export const SUPPLIER_EXPORT_MAX_CONCURRENT = 5;

// Static parts of the Supplier/Filter request; supplierFilters/statusFilter/queryOptions per call.
export const SUPPLIER_FILTER_REQUEST_BASE = {
  offlineSupplierId: null as number | null,
  supplierClientId: null as number | null,
};